<template>
  <div class="multi-avatar" :class="[`extra-${extraUsers.length}`]">
    <div class="multi-avatar__avatar">
      <profile-preview-image
        :uuid="firstUser.uuid"
        :profileId="firstUser.profileId"
        :avatarClasses="['my-0']"
        :avatarSize="48"
      />
    </div>
    <div v-if="extraUsers.length" class="multi-avatar-extra">
      <div
        v-for="user in extraUsers"
        :key="user.uuid"
        class="multi-avatar-extra__avatar"
      >
        <profile-preview-image
          :uuid="user.uuid"
          :profileId="user.profileId"
          :avatarClasses="['my-0']"
          :avatarSize="extraUsers.length === 1 ? 48 : 24"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ProfilePreviewImage from '@/components/profile/ProfilePreviewImage.vue'
export default {
  name: 'MultiAvatar',
  components: {
    ProfilePreviewImage,
  },
  props: {
    users: {
      type: Array,
      default: () => [],
    },
    currentUser: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    extraUsers() {
      return this.filteredMembers.slice(1, 3)
    },
    firstUser() {
      return this.filteredMembers[0] || {}
    },
    filteredMembers() {
      return this.users.filter(user => user.uuid !== this.currentUser)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.multi-avatar {
  display: flex;
  z-index: 2;
  border-radius: 0.5 * $gutter;
  overflow: hidden;

  @include imageAvatar(
    $class-name: 'multi-avatar',
    $height: 48px,
    $width: 48px,
    $radius: 0
  );

  &-extra {
    @include imageAvatar(
      $class-name: 'multi-avatar-extra',
      $height: 48px,
      $width: 24px,
      $radius: 0
    );
    display: flex;
    flex-direction: column;
  }

  &.multi-avatar.extra-1,
  &.multi-avatar.extra-2 {
    .multi-avatar__avatar {
      width: 24px;
    }
  }

  &.multi-avatar.extra-2 {
    .multi-avatar-extra__avatar {
      height: 24px;
    }
  }
}
</style>
